import { initializeVisitorProperties } from '$lib/global/tracking/v4.visitor-properties';
import { appendDomainQueryParam } from '$lib/utils/appendDomainQueryParam';
import { getDataBaseUrl } from '$lib/utils/getDataBaseUrl';
import { initSessionId, getSessionId } from '$lib/utils/initSessionId';

import debug from 'debug';

import type { PageLoad } from './$types';

const debugLog = debug('routes:+page.js');

export const load: PageLoad = async ({ fetch, parent }) => {
    // Get campaignId from parent layout data to initialize session before fetching
    const layoutData = await parent();
    initSessionId(true, layoutData.campaignId);

    const sessionId = getSessionId() || 'error';

    initializeVisitorProperties(sessionId);

    // This reset is only important in case where the user is navigating back to the page
    // on hard reload this is going to be empty anyway
    if (window.analytics) {
        window.analytics.reset();
    }

    const dataBasePath = getDataBaseUrl();
    const res = await fetch(
        `${dataBasePath}/indexPage.json?v=${window.campaignVersionId}${appendDomainQueryParam()}`,
    );
    const pageData = await res.json();

    debugLog(pageData);

    return pageData;
};
